export const MY_SPACE_URL = Object.freeze({
  path: '/my-space',
  search: {
    name: 'my-space.search',
    path: '/search',
  },
  articles: {
    name: 'my-space.articles',
    path: '/articles',
  },
  questions: {
    name: 'my-space.questions',
    path: '/questions',
  },
  departments: {
    name: 'my-space.departments',
    path: '/departments',
  },
  tracks: {
    name: 'my-space.tracks',
    path: '/tracks',
  },
  tags: {
    name: 'my-space.tags',
    path: '/tags',
  },
  users: {
    name: 'my-space.users',
    path: '/users',
  },
  ranking: {
    name: 'my-space.ranking',
    path: '/ranking',
  },
});
